import {ReactNode} from "react";
import classNames from "classnames";

import {ModalCloseButton} from "../atoms/ModalCloseButton";

import * as styles from "./ModalLayoutEmptyResponsive.module.css";

interface IProps {
    breakpoint?: string;
    children?: ReactNode;
    className?: string;
    closeButtonVariant?: "default" | "rounded" | "none";
}

export const ModalLayoutEmptyResponsive = (props: IProps) => {
    const {className, closeButtonVariant, children} = props;

    return (
        <div className={classNames(className, styles.wrapper)}>
            <ModalCloseButton className={styles.modalCloseButtonStyle} variant={closeButtonVariant} />
            {children}
        </div>
    );
};
import {ReactNode} from "react";
import classNames from "classnames";

import {ModalCloseButton} from "../atoms/ModalCloseButton";

import * as styles from "./ModalLayoutEmptyResponsive.module.css";

interface IProps {
    breakpoint?: string;
    children?: ReactNode;
    className?: string;
    closeButtonVariant?: "default" | "rounded" | "none";
}

export const ModalLayoutEmptyResponsive = (props: IProps) => {
    const {className, closeButtonVariant, children} = props;

    return (
        <div className={classNames(className, styles.wrapper)}>
            <ModalCloseButton className={styles.modalCloseButtonStyle} variant={closeButtonVariant} />
            {children}
        </div>
    );
};
